// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2CrBN","footer":"ModalInfo_footer__2VjXK"};